var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFileHtml = function SvgIconFileHtml(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.875 2.375a1.75 1.75 0 0 0-1.75 1.75v7.5a1 1 0 1 0 2 0v-7.25h7.75v5a1 1 0 0 0 1 1h5v1.25a1 1 0 1 0 2 0v-3a1 1 0 0 0-.293-.707l-5.25-5.25a1 1 0 0 0-.707-.293zm13.336 6-3.336-3.336v3.336z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.125 16.375h-1.75v4.25a1 1 0 1 1-2 0v-4.25h-1.75v4.25a1 1 0 1 1-2 0V19h-1.75v1.625a1 1 0 1 1-2 0v-5.25a1 1 0 1 1 2 0V17h1.75v-1.625a1 1 0 0 1 1-1h7.489q.042 0 .085.003a1 1 0 0 1 .733.406l1.443 1.924 1.45-1.933a1 1 0 0 1 1.8.6v5.25a1 1 0 1 1-2 0v-2.25l-.45.6a1 1 0 0 1-1.6 0l-.45-.6v2.25a1 1 0 1 1-2 0zM20.625 14.375a1 1 0 0 1 1 1v4.25h1.25a1 1 0 1 1 0 2h-2.25a1 1 0 0 1-1-1v-5.25a1 1 0 0 1 1-1"
  }))));
};
export default SvgIconFileHtml;